
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ED2939","d":"M0 0h150v100H0z"}}),_c('path',{attrs:{"fill":"#002395","d":"M0 0h20v44.33H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M20 0h20v44.33H20z"}}),_c('path',{attrs:{"fill":"none","stroke":"#FFF","stroke-width":"3","d":"M0 44.33h62.75V0"}}),_c('path',{attrs:{"fill":"#FFF","d":"M108.08 43.29L87.96 23.17h40.25l-20.13 20.12zm-6.7 6.71L81.25 29.88v40.25L101.38 50zm6.7 6.71L87.96 76.83h40.25l-20.13-20.12zm6.71-6.71l20.13-20.13v40.25L114.79 50z"}})])
          )
        }
      }
    